import { useTranslation } from "react-i18next";

const statusOptions = ["ok", "alarm", "warning", "error"];

const useDeviceStatus = () => {
  const { t } = useTranslation();

  return statusOptions.map(status => ({
    value: status,
    label: t(`devices.common.statuses.${status}`)
  }));
};

export default useDeviceStatus;
